// extracted by mini-css-extract-plugin
module.exports = {"mobileBreadcrumbs":"breadcrumbs_mobileBreadcrumbs__2JY5e"};